import raf from 'raf';

function setDirection(context, headerElement, y) {
  const diff = Math.abs(y - context.prevY);
  const currentDir =
    document.documentElement.getAttribute('data-scrolldir') || 'up';

  let newDir;
  if (y < 100) {
    newDir = 'up';
  } else if (diff > 20) {
    newDir = y > context.prevY ? 'down' : 'up';
  }

  if (newDir && newDir !== currentDir) {
    document.documentElement.setAttribute('data-scrolldir', newDir);
    context.updating = true;
    headerElement.addEventListener(
      'transitionend',
      () => {
        context.updating = false;
      },
      { once: true }
    );
  }

  context.prevY = y;
}

export default function(context, headerElement, scrollableElement) {
  context.updating = false;
  context.prevY = 0;

  return function scrollDir() {
    if (context.updating) return;

    const y = scrollableElement
      ? scrollableElement.scrollTop
      : window.scrollY || window.pageYOffset;

    raf(function() {
      setDirection(context, headerElement, y);
    });
  };
}



// WEBPACK FOOTER //
// ./shared/utils/scrolldir.js